define('modules/editor/models/elements/image',['require','exports','module','./base'],function(require, exports, module){
  "use strict";

  var BaseElement = require("./base");

  module.exports = BaseElement.extend({
    initialize: function() {
      module.exports.__super__.initialize.apply(this, arguments);
      this.getPropertyGroup("geometry").set({ width: 1, height: 1 });

      this.listenTo(this.getPropertyGroup("image:content"), "change",
                    this.onContentChange);

      this.listenTo(this.getPropertyGroup("geometry"), "change",
                    this.onGeometryChange);
    },
    name: "element:image",
    defaultNameKey:"image",
    propertyGroups: [
      {
        name: "image:content",
        defaults: {
          "altText": "",
          "title": "",
          "linkUrl": "",
          "linkTarget": "",
          "imageUrl": ""
        }
      },
      {
        name: "idclass",
        defaults: {
          "id": "",
          "className": ""
        }
      },
      {
        name: "border",
        defaults: {
          type: "none",
          width: 1,
          color: "#000000",
          position: "in",
          top: true,
          bottom: true,
          left: true,
          right: true,
          radius: 0
        }
      }
    ],
    onContentChange: function() {
      //flag to avoid auto-resize upon image upload
      this.hasContent = false;
    },
    onGeometryChange: function(geo) {
      if (!this.changed || !geo) {
        // first one is free (setup)
        this.changed = true;
        return;
      }
      if(!this.hasContent){
        this.hasContent = true;
        return;
      }
      var changed = geo.changedAttributes(),
          prev = geo.previousAttributes(),
          w = +geo.get("width"),
          h = +geo.get("height"),
          r = +prev.width/+prev.height;
      if ("width" in changed || "height" in changed) {
        if (+prev.width === w && +prev.height !== h) {
          geo.set({width: Math.round(+h * r)});
          _.delay(_.bind(geo.trigger, geo, "change", geo), 5);
        } else if (+prev.height === h && +prev.width !== w) {
          geo.set({height: Math.round(+w / r)});
          _.delay(_.bind(geo.trigger, geo, "change", geo), 5);
        }
      }
    }
  });
});

